import { nativeBridge } from './nativeBridge';

/**
 * 设置title
 */
export function setPageTitle(params) {
  const paramsToNative = {
    path: 'page_title',
    query: params,
  };
  nativeBridge(paramsToNative);
  return true;
}

/**
 * 分享
 * path: share_h5
 */
export function  share({
  title,
  desc,
  url,
  coverUrl,
}, callback) {
  const params = {
    title,
    desc,
    url,
    coverUrl,
  };
  const paramsToNative = {
    query: params,
    path: 'share_h5',
  };
  nativeBridge(paramsToNative, callback);
  return true;
}

/**
 * title 右上角的share
*/
export function initNavbarShare({
  title,
  desc,
  coverUrl,
}, callback) {
  const params = {
    title,
    desc,
    coverUrl,
  };
  const paramsToNative = {
    query: params,
    path: 'init_navbar_share',
  };
  nativeBridge(paramsToNative, callback);
  return true;
}
